import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import CategoryPage from "./pages/CategoryPage/CategoryPage";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu/:categoryId" element={<CategoryPage />} />
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
